"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleFieldView = void 0;
exports.SimpleFieldView = {
    viewInline: function (field) {
        return field.displayValue;
    },
    viewDetail: function (field) {
        return null;
    },
    viewEdit: function (field, state) {
        return exports.SimpleFieldView.viewInline(field, state);
    }
};
//# sourceMappingURL=field.view.js.map